import styled from 'styled-components';

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  height: 26px;
  background: ${(props) => props.theme.colors.outline};
  border-radius: 6px;
  min-width: fit-content;
  cursor: default;

  svg path {
    fill: ${(props) => props.theme.colors.red};
  }
`;

const Popup = styled.div`
  position: fixed;
  z-index: 10000;
  background-color: ${(props) => props.theme.colors.widget_background};
  border: 1px solid ${(props) => props.theme.colors.red};
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 220px;
  max-width: 320px;
  box-shadow: ${(props) => props.theme.shadows.dropdown};
  pointer-events: none;
`;

const PopupTitle = styled.div`
  color: ${(props) => props.theme.colors.text};
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
`;

const PopupList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const PopupListItem = styled.li`
  color: ${(props) => props.theme.colors.red};
  font-size: 12px;
  line-height: 1.4;
`;

export default {
  IconWrapper, Popup, PopupTitle, PopupList, PopupListItem,
};
